import { pipe } from "fp";

import { creator, effects, reducer, type } from "~/Action/Definition";
import * as Messaging from "~/Messaging";
import { Request } from "~/Request";

import { Post } from "./Request";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Message send requested" as const),
    creator((text: string) => ({ text })),
    reducer(({ state }) => ({
      active: state.messages.active,
    })),
    effects(
      ({
        dispatch,
        state: { context, companies, messages },
        action: { text },
      }) =>
        messages.active
          ? pipe(
              context,
              Post.request({
                ...companies.current,
                driver: messages.active,
                text: text,
              }),
              Request.onSuccess(() =>
                dispatch(
                  Messaging.MessageInteraction.Action.Updated.create(
                    messages.active
                  )
                )
              )
            )()
          : {}
    )
  );
}
